import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';

import store from '@/store';
import { conduitApi } from '../api';
import { Meta, Response, ResponseSingle, Query, ULID } from '../models';
import { PaymentForm, Payment, PaymentFormEdit } from '../models/payment';

@Module({
	namespaced: true,
	name: 'payment',
	store,
	dynamic: true
})
class PaymentModule extends VuexModule {
	payment: Payment = {} as any;

	payments: Payment[] = [];

	meta: Meta = {};

	paymentIntent: string = '';

	balance: number = 0;

	@Mutation
	setAll(payments: Response): void {
		this.payments = payments.data as Payment[];
		this.meta = payments.meta as Meta;
	}

	@Mutation
	set(payment: ResponseSingle): void {
		this.payment = payment.data as Payment;
	}

	@Mutation
	setPaymentIntent(response: ResponseSingle): void {
		const data = response.data as {
			paymentIntentSecret: string;
		};
		this.paymentIntent = data.paymentIntentSecret;
	}

	@Mutation
	setBalance(response: ResponseSingle): void {
		const data = response.data as {
			balance: number;
		};
		this.balance = data.balance as number;
	}

	@Action({ commit: 'setAll', rawError: true })
	async getAll(query: Query): Promise<Response> {
		try {
			const response = await conduitApi.get(`/customers/${query.customerID}/paymentMethods`, {
				params: query.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'set', rawError: true })
	async get(query: Query): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/customers/${query.customerID}/paymentMethods/${query.id}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async create(payment: PaymentForm): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.post(
				`/customers/${payment.customerId}/paymentMethods`,
				JSON.stringify(payment)
			);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async update(payment: PaymentFormEdit): Promise<void> {
		try {
			await conduitApi.put(`/customers/${payment.customerId}/paymentMethods/${payment.id}`, JSON.stringify(payment));
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async delete(query: Query): Promise<void> {
		try {
			await conduitApi.delete(`/customers/${query.customerID}/paymentMethods/${query.id}`);
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setPaymentIntent', rawError: true })
	async createPaymentIntent(obj: { id: ULID; amount: number }): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.post(`/customers/${obj.id}/balance`, JSON.stringify({ amount: obj.amount }));
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setBalance', rawError: true })
	async getBalance(customerID: ULID): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/customers/${customerID}/balance`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
}

export default getModule(PaymentModule);
